var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOnGlyph16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#EyeOnGlyph16x16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.25 9.602C1.934 6.327 4.785 4 7.99 4c3.207 0 6.057 2.327 6.74 5.602a.5.5 0 0 0 .98-.204C14.934 5.673 11.683 3 7.99 3 4.299 3 1.049 5.673.27 9.398a.5.5 0 1 0 .98.204M7.98 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "EyeOnGlyph16x16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgEyeOnGlyph16X16;